const defaultDireccionForm = {
	// tipo: null,
	direccion: null,
	cp: null,
	localidad: null,
}

export default defaultDireccionForm;
